import { ApiEndPoints, NetworkManager } from "../network";

export class TalukServices {
  static getAllTaluks = () => {
    return NetworkManager.getInstance().appRequest({
      method: "get",
      url: ApiEndPoints.taluks
    });
  };

  static addTaluk = (taluk) => {
    return NetworkManager.getInstance().appRequest({
      method: "post",
      url: ApiEndPoints.taluks,
      data: { ...taluk },
    });
  };

  static updateTaluk = (id, taluk) => {
    return NetworkManager.getInstance().appRequest({
      method: "put",
      url: ApiEndPoints.taluks,
      data: { ...id, ...taluk },
    });
  };

  static deleteTaluk = (id) => {
    return NetworkManager.getInstance().appRequest({
      method: "delete",
      url: ApiEndPoints.taluks + "/" + id,
      data: { ...id },
    });
  };
}
